import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';

const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #03103b;
  padding: 96px 0 !important;
`;

const SectionTitle = styled(H1)`
  padding: 0 0 20px;
  color: #ffffff;
  @media (max-width: 520px) {
    text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;
const Rectangle = styled.div`
  width: 80%;
  max-width: 750px;
  padding: 2rem;
  // text-align:center;
  // max-height: 100px;
  background-color: #298de5;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
`;
const MiddleText = styled.span`
  padding: 0 0 1rem;
  color: #fff;
  font-size: 18px;
  @media (max-width: 520px) {
    padding: 1rem 2rem;
  }
`;

export default () => (
  <>
    <Section>
      <SectionTitle>Grow Your Android Markets with Esper</SectionTitle>
      <MiddleText>
        We’re creating an ecosystem of Android solutions providers for open
        collaboration
      </MiddleText>
      <Rectangle>
        Together, we can help your customers succeed with Esper’s solution
        partnerships and products for hardware, customized Android OS, cloud
        deployment, and ISV integration.
      </Rectangle>
    </Section>
  </>
);
